export const INVOICES = 'NUMBER OF INVOICES';
export const PAYMENT_DATE = 'PAYMENT DUE';
export const TOTAL_AMOUNT = 'TOTAL AMOUNT';

export const DATE = 'DATE';
export const SUPPLIER_ID = 'SUPPLIER ID';
export const FARM_NAME = 'FARM NAME';
export const TALLY = 'TALLY';
export const SPECIES = 'SPECIES';
export const AMOUNT = 'AMOUNT';